// Encounter.period.end, held to the FHIR invariant that a period cannot end before it starts.
//
// per-1 (`start.hasValue().not() or end.hasValue().not() or (start <= end)`) is enforced by
// Aidbox, which answers a violating write with 422 and drops it. The write is the last step of
// finishing a form or a visit, so a rejected one leaves the record stuck in progress (#5945).

/**
 * The end to stamp on an Encounter.period: `end`, or `start` when `end` would fall earlier.
 *
 * Clamping to `start` yields a zero-length period. That is deliberate — the alternative is
 * moving the start, which would rewrite when the visit actually began.
 *
 * An unparseable or missing start cannot be compared against, so `end` is returned untouched
 * rather than guessed at; callers that self-heal a bad start do so before reaching here.
 *
 * @param {string} [start] Encounter.period.start
 * @param {string} [end] the intended end; defaults to now
 * @returns {string}
 */
export function encounterPeriodEnd(start, end = new Date().toISOString()) {
    const startMs = Date.parse(start);
    const endMs = Date.parse(end);

    if (Number.isNaN(startMs) || Number.isNaN(endMs)) return end;

    return endMs < startMs ? start : end;
}
